import { useState } from 'react';
import type { KatalogEndpunkt } from '../gql/graphql.ts';

export type KatalogAuswahl = Record<string, string[]>;

export type AttributeToggle = 'alle' | 'keine';

export type KatalogAuswahlSteuerung = {
  katalogAuswahl: KatalogAuswahl;
  toggleEndpunkt: (endpunkt: KatalogEndpunkt) => void;
  toggleAttribut: (endpunktName: string, attributName: string) => void;
  toggleAlleAttribute: (
    endpunkt: KatalogEndpunkt,
    toggle: AttributeToggle,
  ) => void;
};

export function useKatalogAuswahl(
  startAuswahl: KatalogAuswahl,
): KatalogAuswahlSteuerung {
  const [auswahl, setAuswahl] = useState<KatalogAuswahl>(startAuswahl);

  function toggleEndpunkt(endpunkt: KatalogEndpunkt) {
    setAuswahl((vorher) => {
      if (endpunkt.name in vorher) {
        const { [endpunkt.name]: _, ...rest } = vorher; // Key entfernen
        return rest;
      }
      return {
        ...vorher,
        [endpunkt.name]: endpunkt.attribute.map((a) => a.name),
      };
    });
  }

  function toggleAttribut(endpunktName: string, attributName: string) {
    setAuswahl((vorher) => {
      const gewaehlt = vorher[endpunktName] ?? [];
      const neu = gewaehlt.includes(attributName)
        ? gewaehlt.filter((name) => name !== attributName)
        : [...gewaehlt, attributName];
      return { ...vorher, [endpunktName]: neu };
    });
  }

  function toggleAlleAttribute(
    endpunkt: KatalogEndpunkt,
    toggle: AttributeToggle,
  ) {
    setAuswahl((vorher) => {
      const neu =
        toggle === 'alle' ? endpunkt.attribute.map((a) => a.name) : [];
      return { ...vorher, [endpunkt.name]: neu };
    });
  }

  return {
    katalogAuswahl: auswahl,
    toggleEndpunkt,
    toggleAttribut,
    toggleAlleAttribute,
  };
}

export function checkboxZustand(
  gewaehlteAttribute: string[] | undefined,
  anzahl: number,
): boolean | 'indeterminate' {
  if (gewaehlteAttribute === undefined) {
    return false;
  }
  if (anzahl === 0 || gewaehlteAttribute.length === anzahl) {
    return true;
  }
  return 'indeterminate';
}
